import * as React from 'react';
import styled from '@emotion/styled';
import { MDXProvider } from '@mdx-js/react';

import ThemeProvider from './theme/themeProvider';
import mdxComponents from './mdxComponents';
import Sidebar from './sidebar';
import RightSidebar from './rightSidebar';
import config from '../../config.js';
import { useState } from 'react';
import { useRef } from 'react';

const Wrapper = styled('div')`
  display: flex;
  ${'' /* justify-content: space-between; */}
  background: ${({ theme }) => theme.colors.background};
  position: relative;

  .sideBarUL li a {
    color: ${({ theme }) => theme.colors.text};
    font-family: MiSans;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    /* identical to box height */
    text-transform: capitalize;
    color: rgba(2, 5, 9, 0.8);
    -webkit-transition: all 0.5s;
    transition: all 0.5s;
  }

  .sideBarUL .item > a:hover {
    background-color: ${({ theme }) => theme.colors.hoverColor};
    color: #0d94ff !important;
  }

  @media only screen and (max-width: 767px) {
    display: block;
  }
`;

const Content = styled('main')`
  justify-content: center;
  padding: 48px 30px 0 10px;
  display: flex;
  background: ${({ theme }) => theme.colors.background};

  table tr {
    background: ${({ theme }) => theme.colors.background};
  }

  @media (min-width: 767px) and (max-width: 1440px) {
    padding-left: 0;
    margin: 0 10px;
    padding: 48px 50px 0 55px;
    width: 100%;
  }

  @media only screen and (max-width: 767px) {
    padding-left: 0;
    margin: 48px 0px;
    padding: 0px 30px 0 30px;
    width: 100%;
  }
`;

const MaxWidth = styled('div')`
  @media only screen {
    width: 100%;
    max-width: 900px;
    position: relative;
    display: flex;
    flex-direction: column;
    flex: 1;
    margin: 0 auto;
  }
`;

const LeftSideBarWidth = styled('div')`
  width: 450px;
`;

const RightSideBarWidth = styled('div')`
  width: 224px;
`;

const Layout = ({ children, location }) => {
  const [isShowLeftNav, setIsShowLeftNav] = useState(false);
  const btnRef = useRef(1);
  const imgRef = useRef(2);
  const [textDec,setTextDec]=useState('');
  const handleShowLeftNav = (event) => {
    setIsShowLeftNav((state) => !state);
    // 点击后按钮会变色
    if(isShowLeftNav === true){
      btnRef.current.style.background = 'rgba(13,132,255,0.03)';
      btnRef.current.style.color = '#0D84ff';
      btnRef.current.style.marginLeft = "-220px";
      imgRef.current.src = btn;
    }else{
      btnRef.current.style.background = '#0D84ff';
      btnRef.current.style.color = '#fff';
      imgRef.current.src = btn1;
      btnRef.current.style.marginLeft = "5px";
    }
  };


  const btn = require('../components/images/btn.svg').default;
  const btn1 = require('../components/images/btn1.svg').default;

  //首屏按钮样式调整
  React.useEffect(()=>{
    const resize=()=>{
      if(window.innerWidth <= 1440){
        btnRef.current.style.width = 58+'px';
        setTextDec('')
      }
      else{
        btnRef.current.style.width = 161+'px';
        setTextDec('Navigation')
      }
    }
     window.addEventListener('resize',resize)
    return ()=>{
      window.removeEventListener('resize',resize)
    }  
  })

  return (
    <ThemeProvider location={location}>
      <MDXProvider components={mdxComponents}>
        <Wrapper>
          <div className="nav-btn-wrapper">
            <button ref={btnRef} onClick={handleShowLeftNav}>
              <img
                ref={imgRef}
                src={btn}
              />
              <span>{textDec}</span>
            </button>
          </div>
          {isShowLeftNav ? (
            <LeftSideBarWidth className={'hiddenMobile'}>
              <Sidebar location={location} />
            </LeftSideBarWidth>
          ) : null}
          {config.sidebar.title ? (
            <div
              className={'sidebarTitle sideBarShow'}
              dangerouslySetInnerHTML={{ __html: config.sidebar.title }}
            />
          ) : null}
          <Content>
            <MaxWidth>{children}</MaxWidth>
          </Content>
        </Wrapper>
      </MDXProvider>
    </ThemeProvider>
  );
};

export default Layout;
